<a [href]="authorUrl" (click)="handlePresentationMode()">
  <cite class="byline">
    <bulb-user-avatar [displayProps]="displayProps" class="byline__avatar"></bulb-user-avatar>
    <span>{{ displayProps.displayName }}</span>
  </cite>
</a>
